<div class="bar-graph">
    <label class="y-axis">
        {{yAxis}}
    </label>
        <div 
            class="bar-graph-inner"
            [style.paddingTop.%]="height"
            >
            <div 
                class="bars-container"
                [style.width.%]="width"
                >
                <app-bar
                    style="width: inherit; height: inherit; display: inherit;"
                    *ngFor="let bar of bars"
                    [bar]='bar'
                    [numberOfBars]='bars.length'
                    [tallestBar]='tallestBar'
                    [total]="bar.size"
                    [colors]="colors"
                    [isCurrency]="isCurrency">
                </app-bar>
            </div>
            <label class="x-axis">
                {{xAxis}}
            </label>
        </div>
</div>
